import { Route, Routes } from "react-router-dom";
import { ThreeToSixMonthFollowUpReport } from "./ThreeToSixMonthFollowUpReport";
import { TissueReportSlugs } from "../../models";

export function TissueReportRoutes() {
    return (
        <Routes>
            <Route path={TissueReportSlugs.ThreeToSixMonthFollowUp} element={<ThreeToSixMonthFollowUpReport />} />
        </Routes>
    );
}
